export default __webpack_public_path__ + "static/media/contact.2b820475.svg";